import { createRootRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import { Loader2 } from 'lucide-react'
import { AppLayout } from '@/components/layout/AppLayout'
import { useAuth } from '@/contexts/AuthContext'

export const Route = createRootRoute({
  component: RootComponent,
})

function useShowSidebar() {
  const { location } = useRouterState()
  const path = location.pathname
  return path.startsWith('/projects') || path === '/workshops' || path === '/standup' || path === '/tickets'
}

function useNeedsAuth() {
  const { location } = useRouterState()
  const path = location.pathname
  return path.startsWith('/projects') || path === '/workshops' || path === '/standup' || path === '/tickets'
}

function RootComponent() {
  const showSidebar = useShowSidebar()
  const needsAuth = useNeedsAuth()
  const { isLoading, isAuthenticated, isClerkSyncing } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!needsAuth || isLoading || isClerkSyncing) return
    if (!isAuthenticated) {
      navigate({ to: '/', replace: true })
    }
  }, [needsAuth, isLoading, isClerkSyncing, isAuthenticated, navigate])

  if (needsAuth) {
    if (isLoading || isClerkSyncing) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-gray-50">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-hidden />
        </div>
      )
    }
    if (!isAuthenticated) {
      return null
    }
  }

  // Login (/), Verify (/verify), SSO Clerk (/sso-callback) : pas de sidebar
  if (!showSidebar) {
    return <Outlet />
  }

  // Projets, Dashboard, Utilisateurs, Détail projet, Workshops, Tickets : layout avec sidebar
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  )
}

